module.exports = __webpack_public_path__ + "img/challenge.44396858.svg";